import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { has } from 'lodash';

const initialState = {
  places: { count: 0, rows: [] },
  loading: false,
  place: {},
  checkDelete: {},
  placesLeafs: { count: 0, rows: [] },
  placesRoots: { count: 0, rows: [] },
  openedPlaces: {},
  searchText: '',
  copyPlace: {},
  mapConfig: {
    latitude: 0,
    longitude: 0,
    zoom: 11,
    site: null,
    rootMarkers: true,
    persisted: false,
  }
};

const setMapConfig = (state, action) => {
  return updateObject(state, { mapConfig: action.config });
};

const requestPlacesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchPlacesByIdSuccess = (state, action) => {
  return updateObject(state, {
    place: action.place,
    loading: false
  });
};

const fetchPlacesSuccess = (state, action) => {
  let places = action.places;
  places.rows.forEach(place => {

    place.highlight = false;

    if (state.openedPlaces[place._id]) {
      place.isOpen = true;
    }
    if (place.path.indexOf(state.searchText) !== -1 && state.searchText !== "") {
      place.highlight = true;
    }

  });
  return updateObject(state, {
    places: places,
    loading: false
  });
};

const searchTextPlaces = (state, action) => {
  return updateObject(state, {
    searchText: action.searchText,
  });
}

const searchPlaces = (state, action) => {
  let places = { ...state.places };
  places.rows.forEach(place => {
    place.highlight = false;

    if (place.name.toLowerCase().indexOf(state.searchText.toLowerCase()) !== -1 && state.searchText !== "") {
      place.highlight = true;
      let parentId = place.parent;

      let cont = 0;
      while (true) {
        const parentPlace = places.rows.filter(pl => pl._id === parentId)[0];
        cont++;
        if (parentPlace && !parentPlace.isOpen) {
          parentPlace.highlight = true;
          if (parentPlace.isRoot) {
            break;
          } else {
            parentId = parentPlace.parent
          }
        } else {
          break;
        }
      }

    }
  });

  return updateObject(state, {
    places: { ...state.places, rows: places.rows },
  });
};

const fetchPlacesLeafsSuccess = (state, action) => {
  return updateObject(state, {
    placesLeafs: action.placesLeafs,
    loading: false
  });
};

const fetchPlacesRootsSuccess = (state, action) => {
  return updateObject(state, {
    placesRoots: action.placesRoots,
    loading: false
  });
};

const requestPlacesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deletePlacesSuccess = (state, action) => {
  const newRows = state.places.rows;
  const index = newRows.findIndex(nr => nr._id === action.place._id)
  newRows.splice(index, 1);
  return updateObject(state, { loading: false, places: updateObject(state.places, { rows: newRows }) });
}

const checkDeletePlacesSuccess = (state, action) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

const updatePlacesSuccess = (state, action) => {
  const newRows = state.places.rows;
  const index = newRows.findIndex(nr => nr._id === action.place._id)
  newRows[index] = action.place
  return updateObject(state, { loading: false, places: updateObject(state.places, { rows: newRows }) });
}

const postPlacesSuccess = (state, action) => {
  const newRows = state.places.rows;
  newRows.push(action.place);
  if (action.place.parent) {
    const indexParent = newRows.findIndex(row => row._id === action.place.parent);
    newRows[indexParent].isOpen = true;
  }
  const newCount = state.places.count + 1
  return updateObject(state, { loading: false, places: updateObject(state.places, { count: newCount, rows: newRows }) });
}

const tooglePlaces = (state, action) => {
  const prevNode = [...state.places.rows]
  const index = prevNode.findIndex(row => row._id === action.node._id)
  prevNode[index].isOpen = !prevNode[index].isOpen

  let prevOpenedPlaces = { ...state.openedPlaces };

  if (!prevNode[index].isOpen) {
    if (has(prevOpenedPlaces, action.node._id)) {
      delete prevOpenedPlaces[action.node._id]
    }
  } else {
    prevOpenedPlaces[action.node._id] = true
  }

  return updateObject(state, { places: updateObject(state.places, { rows: prevNode }), openedPlaces: prevOpenedPlaces });
}

const setCopyPlace = (state, action) => {

  const placesClone = [...state.places.rows]

  let parentPlace = placesClone.filter(place => place._id === action.place._id)
  parentPlace[0].selectedForCopy = true;
  placesClone.forEach(places => places.selectedForCopy = false);

  while(parentPlace.length !== 0) {
    parentPlace.forEach(parent => {
      parent.selectedForCopy = true;
      const newParent = placesClone.filter(place => place.parent === parent._id);
      const index = parentPlace.findIndex(pp => pp._id === parent._id);
      parentPlace.splice(index, 1);
      parentPlace = parentPlace.concat(newParent)
    })
  }

  return updateObject(state, {copyPlace: action.place, places: updateObject(state.places, { rows: placesClone })});
}

const clearCopyPlace = (state, action) => {
  const placesClone = [...state.places.rows]
  placesClone.forEach(places => places.selectedForCopy = false);
  return updateObject(state, {copyPlace: {}, places: updateObject(state.places, { rows: placesClone })});
}

const copyPastePlaceSuccess  = (state, action) => {
  let places = action.places;
  places.rows.forEach(place => {

    place.highlight = false;

    if (state.openedPlaces[place._id]) {
      place.isOpen = true;
    }
    if (place.path.indexOf(state.searchText) !== -1 && state.searchText !== "") {
      place.highlight = true;
    }

  });
  return updateObject(state, {
    places: places,
    loading: false,
  });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_PLACES_START: return requestPlacesStart(state, action);
    case actionTypes.FETCH_PLACES_SUCCESS: return fetchPlacesSuccess(state, action);
    case actionTypes.FETCH_PLACES_LEAFS_SUCCESS: return fetchPlacesLeafsSuccess(state, action);
    case actionTypes.FETCH_PLACES_ROOTS_SUCCESS: return fetchPlacesRootsSuccess(state, action);
    case actionTypes.REQUEST_PLACES_FAIL: return requestPlacesFail(state, action);
    case actionTypes.DELETE_PLACES_SUCCESS: return deletePlacesSuccess(state, action);
    case actionTypes.CHECK_DELETE_PLACES_SUCCESS: return checkDeletePlacesSuccess(state, action);
    case actionTypes.UPDATE_PLACES_SUCCESS: return updatePlacesSuccess(state, action);
    case actionTypes.POST_PLACES_SUCCESS: return postPlacesSuccess(state, action);
    case actionTypes.TOOGLE_PLACES: return tooglePlaces(state, action);
    case actionTypes.FETCH_PLACES_BY_ID_SUCCESS: return fetchPlacesByIdSuccess(state, action);
    case actionTypes.SEARCH_TEXT_PLACES: return searchTextPlaces(state, action);
    case actionTypes.SEARCH_PLACES: return searchPlaces(state, action);
    case actionTypes.SET_COPY_PLACE: return setCopyPlace(state, action);
    case actionTypes.CLEAR_COPY_PLACE: return clearCopyPlace(state, action);
    case actionTypes.COPY_PASTE_PLACE_SUCCESS: return copyPastePlaceSuccess(state, action);
    case actionTypes.SET_MAP_CONFIG: return setMapConfig(state, action);


    default: return state;
  }
};

export default reducer;
